import React, {useContext} from 'react';

import {H2, H3, Rating} from "@zooplus/ui-components";
import {QuestionCircle} from "@zooplus/icons";
import {PDPProduct} from "../../../model/BonusPointsProduct";
import LocResourcesContext from "../../../../common/contexts/LocResourcesContext";

interface ReviewsTabProps {
  product: PDPProduct;
  mediaServerUrl: string;
  isMobile: boolean;
}

const ReviewsTab: React.FC<ReviewsTabProps> = ({
  product,
  mediaServerUrl,
  isMobile
}: ReviewsTabProps) => {
  const GLOBAL_PREFIX= 'loy-bp-pdppd';
  const {onFormatLocale} = useContext(LocResourcesContext);

  function getProductImage(): string {
    const folderPattern = /([a-zA-Z0-9])?\.(.*)$/;
    const imageName = product.pictures[0];
    const groups = folderPattern.exec(imageName);
    let folderShortcut = '';
    if (groups && groups.length >= 1) {
      folderShortcut = groups[1];
    }
    return `https://${mediaServerUrl}/bilder/${folderShortcut}/200/${imageName}`;
  }

  const className = isMobile
    ? `${GLOBAL_PREFIX}_accordion-item-content`
    : `${GLOBAL_PREFIX}_tab-content`

  return <div className={`${className} ${GLOBAL_PREFIX}_reviews-tab`}>
    <div className={`${GLOBAL_PREFIX}_first_row`}>
      <img src={getProductImage()} alt={product.title}/>
      <div className={`${GLOBAL_PREFIX}_all-ratings`}>
        <div className={`${GLOBAL_PREFIX}_row v-borders`}>
          <Rating ratingLabel={'Rating'} rating={product.averageRating}/>
          <div
            className={`${GLOBAL_PREFIX}_title`}>{onFormatLocale!('review.total.number', [product.feedback.length ?? 0])}</div>
        </div>
        {[0, 1, 2, 3, 4].map(starCount => {
          const rating = 5 - starCount;
          const reviews = product.feedback
            .filter(f => f.rating === rating);
          const percentage = Math.trunc((reviews.length / product.feedback.length) * 100);
          return <div className={`${GLOBAL_PREFIX}_row rating-group`}>
            <Rating key={starCount} ratingLabel={`Rating ${starCount}`} rating={rating}/>
            <div className={`${GLOBAL_PREFIX}_progress-bar`}>
              <span style={{maxWidth: `${percentage}%`}}></span>
            </div>
            <div className={`${GLOBAL_PREFIX}_count`}>({reviews.length})</div>
          </div>
        })
        }
        <a className={`${GLOBAL_PREFIX}_evaluation-link`} href="/info/legal/help_product_evaluation" target="_blank">
          {onFormatLocale!('helpProductEvaluation.link.text')}
          <QuestionCircle size={12} style={{verticalAlign: 'text-bottom'}} />
        </a>
      </div>
    </div>
    <H2>{onFormatLocale!('productReview.latest.reviews')}</H2>
    {
      product.feedback.length === 0 && <div>
            <span>{onFormatLocale!('productReview.noreviews')}</span>
            <a href="#">{onFormatLocale!('reset.filters.text')}</a>
        </div>
    }
    {
      [0, 1, 2, 3, 4].map(i => {
        if (product.feedback.length <= i) return <></>
        const feedback = product.feedback[i];
        const feedbackDate = new Date(feedback.entryDate).toLocaleDateString();
        return <div key={i}>
          <div>{feedbackDate} {feedback.showReviewerName && <span> | {feedback.name}</span>}</div>
          <Rating ratingLabel={`Rating ${feedback.entryDate}`} rating={feedback.rating} />
          <H3>{feedback.title}</H3>
          <p>{feedback.text}</p>
        </div>
      })
    }
  </div>;
};

export default React.memo(ReviewsTab);
